//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import { formatShortDate } from '@/server/utils/utils-date'

export default {
  name: 'QuestionAnswerItemParticipant',
  props: {
    projectInReview: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => {}
    },
    questionNumber: {
      type: Number,
      default: 1
    },
    // Expand All / Collapse All, forwarded from CategoriesQuestions
    visible: {
      type: Boolean,
      default: false
    },
    toggleKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // collapsed by default; Expand All/Collapse All flips this via the
      // toggleKey watcher below, same as clicking the question does
      questionOpen: false,
      historyOpen: false
    }
  },
  watch: {
    // toggleKey always changes (even to force the same `visible` value twice),
    // so watch it rather than `visible` directly
    toggleKey() {
      this.questionOpen = this.visible
    }
  },
  computed: {
    ...mapGetters({
      getAnswerByQuestion: 'answers/getAnswerByQuestion',
      getIsQuestionAnswered: 'answers/getIsQuestionAnswered',
      getQuestionnaireNamesByQuestionId: 'questionnaires/getQuestionnaireNamesByQuestionId',
      questionsSelected: 'questions/getQuestionsSelected',
      questionsSelectActive: 'questions/getQuestionsSelectActive'
    }),
    questionnaireNames() {
      return this.getQuestionnaireNamesByQuestionId(this.question._id)
    },
    questionAnswer() {
      return this.getAnswerByQuestion(this.question._id)
    },
    answerIsRecalled() {
      return Boolean(this.questionAnswer?.recalled)
    },
    displayAnswerHistory() {
      return Boolean(Object.keys(this.questionAnswer).length)
    },
    questionIsAnswered() {
      return this.getIsQuestionAnswered(this.question._id)
    },
    requirementIsMet() {
      const requirement = this.question.requirement
      const reqMet = this.questionAnswer.requirementMet
      const reqIsMet = (requirement && reqMet) || (requirement && !reqMet && this.questionAnswer.override)
      return reqIsMet
    },
    questionSelected: {
      get() {
        return Boolean(this.questionsSelected.find(q => q._id === this.question._id))
      },
      set(value) {
        if (value) {
          this.setQuestionsSelectedAdd({ 
            _id: this.question._id, 
            text: this.question.text,
            primaryCategory: this.question.primaryCategory,
            secondaryCategory: this.question.secondaryCategory,
            tertiaryCategory: this.question.tertiaryCategory,
            tag: this.question.tag,
            type: this.question.type,
            choices: this.question.choices,
            note: this.question.note,
            phase: this.question.phase,
            required: this.question.required,
            loisDataField: this.question.loisDataField,
            requirement: this.question.requirement
          })
        } else {
          this.setQuestionsSelectedDelete({ 
            _id: this.question._id, 
            text: this.question.text,
            primaryCategory: this.question.primaryCategory,
            secondaryCategory: this.question.secondaryCategory
          })
        }
      }
    },
    lastUpdatedDate() {
      const updates = this.questionAnswer?.answerUpdates
      if (updates && updates.length > 0) {
        const lastUpdate = updates[updates.length - 1]
        return formatShortDate(lastUpdate.created)
      }
      // If answerUpdates array is empty, use answer.updated
      if (this.questionAnswer?.updated) {
        return formatShortDate(this.questionAnswer.updated)
      }
      return '-'
    }
  },
  methods: {
    ...mapActions({
      setQuestionsSelectedAdd: 'questions/setQuestionsSelectedAdd',
      setQuestionsSelectedDelete: 'questions/setQuestionsSelectedDelete'
    })
  }
}
